import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { ModalPaper } from 'Components/Styles/Modals/ModalContainers';

import BaseModal from '../BaseModal';
import { ReactComponent as CheckmarkIcon } from 'resources/images/icons/partialOutlinedCheckIcon.svg';
import { useHistory } from 'react-router';
import { FixedSizeIcon } from 'Components/Styles/Modals/Questionnaire';
import { TitleText, ModalButton } from 'Components/Styles/Modals/Components';


export default function BaselineQuestionnaireCompletedModal() {
    const {t} = useTranslation();
    const history = useHistory();

    function handleDismiss() {
        history.push("/dashboard");
    }

    return (
        <BaseModal
            aria-describedby="baseline-questionnaire-modal-description"
            aria-labelledby="baseline-questionnaire-modal-title"
            onClose={handleDismiss}
            open={true}
        >
            <ModalPaper>
                <Grid container direction="column" alignItems="center" spacing={2}>
                    <Grid item>
                        <FixedSizeIcon component={CheckmarkIcon} color="primary" />
                    </Grid>
                    <Grid item>
                        <TitleText>{t('questionnaire.baselineAlreadyCompleteTitle')}</TitleText>
                    </Grid>
                    <Grid item>
                        <Typography variant="body2" color="textSecondary" align="center">{t('questionnaire.baselineAlreadyCompleteDescription')}</Typography>
                    </Grid>
                    <ModalButton variant="contained" color="primary" size="small" onClick={handleDismiss}>{t('questionnaire.returnToDashboard')}</ModalButton>
                </Grid>
            </ModalPaper>
        </BaseModal>
    );
}